export default __webpack_public_path__ + "static/media/thumbnail.893da8ea.png";